import type { ViewUiRootComponent } from '@salescore/core'
import { useStateWithLocalStorage } from '@salescore/frontend-common'
import { z } from 'zod'

import { ROW_HEIGHT } from '../rsheet/components/body/const'

export const ROW_LINES_COUNT_OPTIONS = [1, 2, 3, 5, 10] as const
export type RowLinesCount = (typeof ROW_LINES_COUNT_OPTIONS)[number]

export const useRowLinesCount = () =>
  useStateWithLocalStorage(`view/navigation/rowLineNum`, 1, z.literal(ROW_LINES_COUNT_OPTIONS))

export const calculateRowLinesCount = (ui: ViewUiRootComponent | undefined, rowLinesCount: RowLinesCount): number =>
  ui !== undefined && (ui.type === 'KpiPivotSheet' || ui.type === 'KpiSheet') ? 2 : rowLinesCount

export const calculateRowHeight = (ui: ViewUiRootComponent | undefined, rowLinesCount: RowLinesCount): number =>
  calculateRowLinesCount(ui, rowLinesCount) * ROW_HEIGHT
